// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d0e5649699fa049ddfd4fab00c3db8550e6d9484.chunk.bundle.js";
};